
// List of the main sections for the PEO application
export const SECTIONS = [
  "Basic Information",
  "Entity Details",
  "Insurance Details",
  "Operational Details",
  "Medical Questionnaire",
  "Workers Comp Assessment",
  "Payroll Schedule",
  "Document Upload",
  "PEO Preferences",
  "Review and Submit"
];

// The validation sections map to more specific keys in the validation logic
export const VALIDATION_SECTIONS = {
  "Basic Information": "Basic Information",
  "Entity Details": "Entity Details",
  "Insurance Details": "Insurance Details",
  "Operational Details": "Operational Details",
  "Medical Questionnaire": "Medical Questionnaire",
  "Workers Comp Assessment": "Workers Comp Assessment",
  "Payroll Schedule": "Staffing & Payroll",
  "Document Upload": "Document Upload",
  "PEO Preferences": "PEO Preferences",
  "Review and Submit": "Review and Submit"
};
